import { contract } from '@numistic/contracts';
import { createORPCClient } from '@orpc/client';
import { ResponseValidationPlugin } from '@orpc/contract/plugins';
import { OpenAPILink } from '@orpc/openapi-client/fetch';
/** Типизированный клиент, построенный из того же контракта, что реализует API. */
export function createApiClient({ baseUrl, fetch = globalThis.fetch, }) {
    const link = new OpenAPILink(contract, {
        url: baseUrl,
        // Ответы проходят через output-схемы контракта: даты становятся Date, чужой формат — ошибкой.
        plugins: [new ResponseValidationPlugin(contract)],
        // Cookie-сессия web-клиента (этап 1.2) должна уходить с каждым запросом.
        fetch: (request, init) => fetch(request, { ...init, credentials: 'include' }),
    });
    return createORPCClient(link);
}
//# sourceMappingURL=index.js.map